import { DefaultScheduler } from "ts-fsrs";
import { memorySchema, type Memory, type ReviewState } from "./domain";
const cache = new Map<number, ReturnType<typeof DefaultScheduler>>();
export function scheduler(retention = 0.9) {
  if (!cache.has(retention))
    cache.set(
      retention,
      DefaultScheduler({
        version: "FSRS-7",
        desiredRetention: retention,
        enableFuzz: false,
        enableShortTerm: true,
        learningSteps: ["1m", "10m"],
        relearningSteps: ["10m"],
        maximumInterval: 36500,
      }),
    );
  return cache.get(retention)!;
}
export function hydrate(m: Memory) {
  return {
    ...m,
    state: m.state as 0 | 1 | 2 | 3,
    dueAt: new Date(m.dueAt),
    lastReviewAt: m.lastReviewAt ? new Date(m.lastReviewAt) : null,
  };
}
export async function newState(cardId: string, now = new Date()): Promise<ReviewState> {
  const s = await scheduler();
  const m = s.newCard({ now });
  return {
    id: cardId,
    cardId,
    model: "FSRS-7",
    version: 0,
    memory: memorySchema.parse(JSON.parse(JSON.stringify({ ...m, cardId }))),
  };
}
export async function schedule(
  before: ReviewState,
  grade: number,
  now: Date,
  retention: number,
) {
  const s = await scheduler(retention);
  if (
    before.memory.lastReviewAt &&
    now.getTime() < Date.parse(before.memory.lastReviewAt)
  )
    throw new Error(
      "Cihaz saati son çalışmadan önce görünüyor. Tarih ve saati düzeltip tekrar dene.",
    );
  const result = s.review({
    card: hydrate(before.memory),
    grade: grade as 1 | 2 | 3 | 4,
    now,
  });
  return {
    after: {
      ...before,
      version: before.version + 1,
      memory: memorySchema.parse(JSON.parse(JSON.stringify(result.card))),
    },
    revlog: JSON.parse(JSON.stringify(result.revlog)) as Record<string, unknown>,
  };
}
export async function retrievability(state: ReviewState, now = new Date()) {
  if (!state.memory.lastReviewAt) return null;
  const s = await scheduler();
  const c = hydrate(state.memory);
  const elapsed = Math.max(
    0,
    s.chrono.difference(new Date(state.memory.lastReviewAt), now),
  );
  return s.model.forgettingCurve(c, elapsed);
}
